<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PNLReportTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import PNLReportTable from './PNLReportTable.vue'

  export default {
    name: 'pnlreport-table',
    components: {PNLReportTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/report/payment/PNLReport.vue